/* eslint-disable prettier/prettier */
// @flow

import { createSelector } from 'reselect'



// Getters
const getFlyerDetails = state => state.flyerDetails
const getFlyers = state => state.flyers

export const getActiveFlyerId = createSelector(
  getFlyerDetails,
  details => details.activeFlyerId
)

export const getActiveFlyer = createSelector(
  [getActiveFlyerId, getFlyers],
  (flyerId, flyers) => flyers[flyerId]
)

export const getFlyerCtas = createSelector(
  getActiveFlyer,
  flyer => (flyer ? flyer.ctas : [])
)



// WEBPACK FOOTER //
// ./src/screens/Flyers/screens/FlyerDetail/selectors.js